import { Routes, Route, Navigate, useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import { useAuth } from './hooks/useAuth'
import Login              from './pages/Login'
import ResetPassword      from './pages/ResetPassword'
import EmpDashboard       from './pages/employee/Dashboard'
import Onboarding         from './pages/employee/Onboarding'
import Policies           from './pages/employee/Policies'
import Timesheets         from './pages/employee/Timesheets'
import TimeOff            from './pages/employee/TimeOff'
import Memos              from './pages/employee/Memos'
import Documents          from './pages/employee/Documents'
import EmpCampus          from './pages/employee/Campus'
import AdminDashboard     from './pages/admin/Dashboard'
import EmployeeRoster     from './pages/admin/EmployeeRoster'
import EmployeeProfile    from './pages/admin/EmployeeProfile'
import Approvals          from './pages/admin/Approvals'
import Performance        from './pages/admin/Performance'
import AdminMemos         from './pages/admin/Memos'
import DocLibrary         from './pages/admin/DocLibrary'
import ClientConfig       from './pages/admin/ClientConfig'
import AdminCampus        from './pages/admin/Campus'
import Helpdesk          from './pages/admin/Helpdesk'
import AdminCalendar     from './pages/admin/AdminCalendar'
import DevRequests      from './pages/admin/DevRequests'
import AdminVisitors    from './pages/admin/AdminVisitors'
import RoleManagement       from './pages/admin/RoleManagement'
import ITChangeManagement  from './pages/admin/ITChangeManagement'
import ITWorkLog           from './pages/admin/ITWorkLog'
import VisitorKiosk     from './pages/employee/VisitorKiosk'
import Requests          from './pages/employee/Requests'
import Calendar          from './pages/employee/Calendar'
import EmployeeLayout     from './components/layout/EmployeeLayout'
import AdminLayout        from './components/layout/AdminLayout'
import ProtectedRoute     from './components/layout/ProtectedRoute'
import Landing  from './pages/Landing'
import ScrollToTop from './components/ScrollToTop' // scroll reset on nav
import Features from './pages/Features'
import Pricing  from './pages/Pricing'
import Platform from './pages/Platform'
import About    from './pages/About'
import Demo     from './pages/Demo'

function RootRedirect({ session, role }) {
  const navigate = useNavigate()
  useEffect(() => {
    const hash = window.location.hash
    const params = new URLSearchParams(window.location.search)
    if (hash && hash.includes('type=recovery')) { navigate('/reset-password' + hash); return }
    if (params.get('demo')) { navigate('/login?demo=' + params.get('demo')); return }
    if (!session) { navigate('/home'); return }
    if (role === 'admin') { navigate('/admin'); return }
    navigate('/dashboard')
  }, [session, role])
  return null
}

export default function App() {
  const { session, role } = useAuth()
  return (
    <>
    <ScrollToTop />
    <Routes>
      <Route path="/"           element={<Landing />} />
      <Route path="/features"       element={<Features />} />
      <Route path="/pricing"        element={<Pricing />} />
      <Route path="/platform"       element={<Platform />} />
      <Route path="/about"          element={<About />} />
      <Route path="/demo"           element={<Demo />} />
      <Route path="/visitor"        element={<VisitorKiosk />} />
      <Route path="/login"          element={<Login />} />
      <Route path="/reset-password" element={<ResetPassword />} />

      <Route element={<ProtectedRoute allowedRoles={['employee','admin']} />}>
        <Route element={<EmployeeLayout />}>
          <Route path="/dashboard"  element={<EmpDashboard />} />
          <Route path="/onboarding" element={<Onboarding />} />
          <Route path="/policies"   element={<Policies />} />
          <Route path="/timesheets" element={<Timesheets />} />
          <Route path="/time-off"   element={<TimeOff />} />
          <Route path="/memos"      element={<Memos />} />
          <Route path="/documents"  element={<Documents />} />
          <Route path="/campus"     element={<EmpCampus />} />
          <Route path="/requests"   element={<Requests />} />

          <Route path="/calendar"   element={<Calendar />} />
        </Route>
      </Route>

      <Route element={<ProtectedRoute allowedRoles={['admin','owner','hr_admin','supervisor']} />}>
        <Route element={<AdminLayout />}>
          <Route path="/admin"                 element={<AdminDashboard />} />
          <Route path="/admin/employees"       element={<EmployeeRoster />} />
          <Route path="/admin/employees/:id"   element={<EmployeeProfile />} />
          <Route path="/admin/approvals"       element={<Approvals />} />
          <Route path="/admin/performance"     element={<Performance />} />
          <Route path="/admin/memos"           element={<AdminMemos />} />
          <Route path="/admin/documents"       element={<DocLibrary />} />
          <Route path="/admin/config"          element={<ClientConfig />} />
          <Route path="/admin/campus"          element={<AdminCampus />} />
          <Route path="/admin/helpdesk"        element={<Helpdesk />} />
          <Route path="/admin/calendar"       element={<AdminCalendar />} />
          <Route path="/admin/dev-requests"    element={<DevRequests />} />
          <Route path="/admin/visitors"         element={<AdminVisitors />} />
          <Route path="/admin/roles"              element={<RoleManagement />} />
          <Route path="/admin/it-changes"         element={<ITChangeManagement />} />
          <Route path="/admin/it-worklog"         element={<ITWorkLog />} />
        </Route>
      </Route>

      <Route path="/" element={<RootRedirect session={session} role={role} />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    </>
  )
}